<template>
  <button
    class="scout-button"
    @click="$emit('click')"
    :disabled="loading"
  >
    <slot>スカウト対象</slot>
  </button>
</template>

<script>
export default {
  name: 'ScoutButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fromProfile: {
      type: Boolean,
      deafult: false,
    },
    applicant: {
      type: Object,
      required: false,
    },
  },
  computed: {
    checkDisabled() {
      if (this.scoutText == 'スカウト対象に追加済') {
        return true;
      } else if (this.applicant.status === 'スカウト対象') {
        return true;
      } else {
        return this.disabled;
      }
    },
    scoutText() {
      if (!this.fromProfile) return 'スカウト対象';

      const { status, new_status } = this.applicant;
      const isAlreadyAdded = new_status === 'スカウト対象' || status === 'コンタクト済み' || status === 'スカウト対象';

      return isAlreadyAdded ? 'スカウト対象に追加済' : 'スカウト対象';
    },
    scoutedButton() {
      if (this.fromProfile) {
        if (
          this.applicant.new_status == 'スカウト対象' ||
          this.applicant.status == 'コンタクト済み'
        ) {
          return 'gray-btn';
        }
      } else {
        return '';
      }
    },
  },
};
</script>

<style scoped>
.gray-btn {
  background-color: #b3b3b3 !important;
  border-color: #b3b3b3 !important;
  color: #3c3c3c !important;
}
.scout-button {
  width: 200px;
  height: 61px;
  border-radius: 30px;
  border: 1px solid #eb5757;
  background: #eb5757;
  color: white;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.scout-button:hover {
  background: white;
  color: #eb5757;
}

.scout-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
